module.exports = __webpack_public_path__ + "img/cv.97839333.svg";